import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, RESULT_MASTER } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.powLnCdList = []; //조회조건에 라인
		state.insnCyclCdList = []; //조회조건에 주기
		state.insnRsltCdList = []; //조회조건에 결과
		state.gridInsnRsltCdList = []; //그리드에 결과
		state.resultMaster = RESULT_MASTER(); //공정순회검사 마스터 한건
		state.resultList = []; //공정순회검사 상세리스트
		state.fileList = []; //파일첨부
		state.selectedRows = []; //리스트에서 선택된 데이터
	},
	[types.SEARCH_PARAMS]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.RESULT_MASTER]: (state, { key, value }) => {
		state.resultMaster[key] = value;
	},
	[types.SELECTED_ROWS]: (state, rows) => {
		state.selectedRows = rows;
	}
};
